import { render } from "./AccountGroup.vue.js?vue&type=template&id=fa2b1464!=!../vue-loader/dist/index.js??ruleSet[0]!./AccountGroup.vue?vue&type=template&id=fa2b1464"
import script from "./AccountGroup.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./AccountGroup.vue?vue&type=script&lang=js"
export * from "./AccountGroup.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./AccountGroup.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__